export default __webpack_public_path__ + "static/media/be-a-paduan-call-out.86698fb2.png";